import { Component, OnInit,ViewChild } from '@angular/core';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { Router } from '@angular/router';
import { JsonPipe } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DashboardService } from '../service/dashboard.service';
import { debounceTime, tap, switchMap, finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { MatTableDataSource, MatPaginator, MatDialog, MatSlideToggleChange,MatSnackBar } from '@angular/material';
import { UpdateBrokerAdminComponent } from 'src/app/dialogs/update-broker-admin/update-broker-admin.component';


@Component({
  selector: 'app-broker-admin',
  templateUrl: './broker-admin.component.html',
  styleUrls: ['./broker-admin.component.scss']
})
export class BrokerAdminComponent implements OnInit {

  userdata;
  currentUser;
  allBrokers: any = [];
  searchdata;

  length: number = 0
  pageIndex: number = 0
  pageSize: number = 5
  pageSizeOptions = [5, 10, 20, 50, 100]

 isActive = true;
accountStatus = "disabled"
pageChange = false;


  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns = ['no',  'firstName', 'lastName', 'email', 'phone', 'company','CompanyCode', 'edit', 'status','refresh']

 
  constructor(
    public service: DashboardService,
    public router: Router,
    private dialog: MatDialog,private _snackBar: MatSnackBar
  ) { 




  }


  getRequestParams(current_page, page_size) {
    let params = {};

    params[`email`] = this.currentUser.email
    params[`role`] = this.currentUser.role

    if (current_page) {
      params[`current_page`] = current_page
    }

    if (page_size) {
      params[`page_size`] = page_size
    }

    return params;
  }


  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userdata'))

  //  console.log("user"+ this.currentUser.this.userdata.email)
  
    this.fetchBrokers();
    this.pageChange = false;


}





fetchBrokers() {

  const params = this.getRequestParams(this.pageIndex , this.pageSize)
  //console.log("params>>>> " + JSON.stringify(params))

  if (this.pageChange) {
    //don't show loading 
  } else {
    Swal.showLoading();
  }


  this.service.getBrokerAdmins(JSON.stringify(params))
    .toPromise()
    .then((response: any) => {
      Swal.close()
      if (response.hasOwnProperty('responseCode') && response.responseCode == '000') {

        this.allBrokers = response.pageData.content
        this.dataSource.data = this.allBrokers
        //this.dataSource.paginator = this.paginator;
        //this.pageIndex = response.page.current
        this.pageSize = response.pageData.pageSize
        this.length = response.pageData.totalElements
        //this.iterator();


        // this.searchdata = this.allBrokers;
        // this.dataSource.paginator = this.paginator;

      } else {
        this.dataSource.data = [];
      }


    })
    .catch(error => {
      (Swal as any).fire({
        title: 'Retrieval Failed',
        text: 'Failed to retrieve policy details',
        icon: 'error'
      })
    })
    .finally(() => {
      Swal.close()
    })


  }



  updateBrokerStatus(status, data) {

    const requestPayload = {
      broker_admin_email: data.broker_admin_email,
      broker_admin_status: status === true ? `1` : `0`,
      broker_admin_modified_by: this.currentUser.email,
    }

   // console.log(requestPayload);


    Swal.showLoading();
    this.service.disableBrokerAdmin(requestPayload)
      .subscribe(response => {
     //   console.log(response);

        Swal.close();
        if (response['responseCode'] === '000') {
          this.fetchBrokers();

          (Swal as any).fire({
            icon: 'success',
            title: 'Successful',
            text: status === true ? `Broker admin account activated` : `Broker admin account disabled`,
          });


        } else {
          (Swal as any).fire({
            icon: 'warning',
            title: 'Oops...',
            text: response['responseMessage'],
            footer: ''
          });
        }

      }, error => {
        (Swal as any).fire({
          icon: 'error',
          title: 'Oops...',
          text: error,
          footer: ''
        });
        Swal.close();
      })



  }



  updateActiveStatus(event: MatSlideToggleChange, element) {
    // console.log(event.checked);
    // console.log(element);

    (Swal as any).fire({
      title: '',
      text: event.checked === false ? `Do you want to disable this user account?` : `Do you want to activate this user account?`,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No, thanks!',
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.value) {

        this.updateBrokerStatus(event.checked, element)

      } else {
        result.dismiss === Swal.DismissReason.cancel
        this.fetchBrokers();
      }

    })


  }

  search(query: string) {
    this.searchdata = (query) ? this.allBrokers.filter(data => data.broker_admin_email.toLowerCase().includes(query.toLowerCase()) 
    || data.broker_admin_last_name.toLowerCase().includes(query.toLowerCase()) 
    || data.broker_admin_first_name.toLowerCase().includes(query.toLowerCase())
     || data.broker_admin_phone.toUpperCase().includes(query.toUpperCase())) : this.allBrokers;
  }



  handlePageChange(event) {
    // console.log("pageIndex>>>> " + event.pageIndex)
    // console.log("pageSize>>>> " + event.pageSize)

    this.pageIndex = event.pageIndex
    this.pageSize = event.pageSize

    this.pageChange = true;
    this.fetchBrokers()
   



  }



  openEditDialog(selectedRow) {
    //console.log(selectedRow);

    const dialogRef = this.dialog.open(UpdateBrokerAdminComponent, {
      disableClose: true,
      data: selectedRow
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'updated') {
        this.fetchBrokers();
      }

    });

  }


  // pin reset 

    //confirm login Password to continue
confirmPassword(broker_admin){
  (Swal as any).fire({
    icon:"question",
    allowOutsideClick:false,
    showCancelButton: true,
    text:"Do you really want to reset this broker admin's pin?",
    reverseButtons: true
  }).then((result:SweetAlertResult)=>{
    if(result.value){
      (Swal as any).fire({
        //title: "Identity Confirmation",
        icon:"warning",
        allowOutsideClick:false,
        showCancelButton: true,
        inputPlaceholder: "Confirm your Password",
        input:"password",
        reverseButtons: true
      })
      .then((result:SweetAlertResult)=>{
           if(result.value){
              Swal.showLoading();
              this.service.getLogin({
                email:this.currentUser.email,
                password:result.value,
                role:'admin'
              })
              .toPromise()
              .then((responseData: any)=>{
                Swal.close();
                if(responseData.hasOwnProperty('responseCode') && responseData.responseCode==='000'){
                    this.openReset(broker_admin)
                }
                else{
                  (Swal as any).fire({
                    title: 'Wrong credentials!',
                    text: 'Please check and try again',
                    icon: 'error',
                  });
                  setTimeout(()=>{this.confirmPassword(broker_admin)},2000);
                }

              }).catch(error=>{
                (Swal as any).fire({
                  title: 'Connection Failed!',
                  text: 'Login Failed',
                  icon: 'error',
                });
                setTimeout(()=>{this.confirmPassword(broker_admin)},2000);
              })
           }
           else
           this.alertSnackBar('No Password was entered','User Not Verified');
         });
    }
  })

   }
      //trigger the snackbar
      alertSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
          duration: 2000,
        });
    }



    openReset(broker_admin){
   //   console.log('selected',broker_admin)
      let payload={
        broker_admin_email:broker_admin.broker_admin_email,
        broker_admin_modified_by:this.currentUser.email,
      //  module: 'agent',
        role: "admin",
      }
      this.service.resetBRokerAdminPin(payload).subscribe((response:any)=>{
         if(response.responseCode=='000')
         (Swal as any).fire({
           icon:'info',
           text:'Account Reset Mail Sent Successfully!'
         });
         else
         (Swal as any).fire({
          icon:'error',
          text:'Account Reset failed!'
        });
      })
      }





  private iterator() {
    const end = (this.pageIndex + 1) * this.pageSize;
    const start = this.pageIndex * this.pageSize;
    const part = this.allBrokers.slice(start, end);
    this.dataSource = part;
  }


addBrokerAdmin() {
  this.router.navigate(['/add-broker-admin'])
}


brokerAdmins() {
  this.router.navigate(['/broker-admin'])
}


}